import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import SvgPinterestIcon from './svgs/PinterestIcon.js';
import { useIcon } from '../../shared-components/icon/index.js';

var pinterestIcon = (props => useIcon(SvgPinterestIcon, SvgPinterestIcon, props));

export { pinterestIcon as default };
